import { env } from "./env";
import { Sans } from "./sdk";

export interface PdfServiceResponse {
  url: string;
  expiresIn: number;
}

const getPdfServiceBaseUrl = () => {
  const baseUrl = env.VITE_API_URI;
  if (!baseUrl) {
    throw new Error("VITE_API_URI is not set");
  }

  let normalizedBaseUrl = baseUrl;
  while (normalizedBaseUrl.endsWith("/")) {
    normalizedBaseUrl = normalizedBaseUrl.slice(0, -1);
  }

  return normalizedBaseUrl;
};

const requestPdfService = async <T>(path: string, init?: RequestInit): Promise<T> => {
  const { id } = await Sans.sdk.core.api.tokens.freshTokens();
  const response = await fetch(`${getPdfServiceBaseUrl()}${path}`, {
    ...init,
    headers: {
      "Content-Type": "application/json",
      "X-ACCESS-TOKEN": id ? `Bearer ${id}` : "",
      ...init?.headers,
    },
  });

  if (!response.ok) {
    const errorBody = await response.text();
    throw new Error(errorBody || `pdf-service request failed with ${response.status}`);
  }

  return (await response.json()) as T;
};

export const downloadNotesPdf = (trainingId: number) =>
  requestPdfService<PdfServiceResponse>("/pdf/notes_download_generate", {
    method: "POST",
    body: JSON.stringify({ trainingId }),
  });

export const downloadCertificate = (trainingId: number, instanceId: string) =>
  requestPdfService<PdfServiceResponse>(`/pdf/certificate_download/${trainingId}/${instanceId}`);
